export default "/_next/static/images/41b1e0bc0a7d157767b22e3c18eda8b5.png";